export const getters = {
    getUsers(state: any): object {
        return state.users;
    },
    getLogins(state: any): object {
        return state.logins;
    },
    getSelectedUser(state: any): object {
        return state.selectedUser;
    },
    getUserModels(state: any): object {
        return state.userModels;
    },
    getSelectedModel(state: any): object {
        return state.selectedModel;
    },
    getSelectedScenario(state: any): object {
        return state.selectedScenario;
    },
    getModelUsers(state: any): object {
        return state.modelUsers;
    },
    getModels(state: any): object {
        return state.models;
    },
    getScenarioStatus(state: any): object {
        return state.scenarioStatus;
    },
    getLoginEditing(state: any): object {
        return state.loginEditing;
    },
};
